<template>
  <div class="tab-ctnr--common">
    <div class="table-area">
      <div class="t-content">
        <el-table
          class="table-comp"
          ref="table"
          :data="tableData"
          v-loading="loading"
          stripe
          border
        >
          <el-table-column
            prop="costDetail"
            min-width="300"
            label="费用名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column min-width="158" label="箱型" show-overflow-tooltip>
            <template v-slot="{ row }">
              {{ detail.chooseContainerType }}</template
            >
          </el-table-column>
          <el-table-column
            prop="price"
            min-width="150"
            label="天数"
            show-overflow-tooltip
          >
            <template v-slot="{ row }">
              {{ $str(row.dayNum, "", "${}天") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="currency"
            min-width="150"
            label="币种"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="price"
            min-width="200"
            label="单价"
            show-overflow-tooltip
          >
            <template v-slot="{ row }">
              <template v-if="$emp(row.price)">
                -
              </template>
              <template v-else>
                <template v-if="!$emp(row.unit)">
                  {{ row.price }}/{{ row.unit }}
                </template>
                <template v-else>
                  {{ row.price }}
                </template>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },

  components: {},
  computed: {
    tableData() {
      if (!this.detail.detentionParseResult) {
        return [];
      }

      return [...this.detail.detentionParseResult];
    }
  },
  data() {
    return {
      loading: false
    };
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
@import "./common.scss";
.tab-ctnr--common {
  .table-area {
    .t-content {
      margin-top: 24px;
    }
  }
}
</style>
